import { render, staticRenderFns } from "./modalDrugOrderViewMedication.vue?vue&type=template&id=52dd1278&"
import script from "./modalDrugOrderViewMedication.vue?vue&type=script&lang=js&"
export * from "./modalDrugOrderViewMedication.vue?vue&type=script&lang=js&"
import style0 from "./modalDrugOrderViewMedication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports